export const ProfessionalWorkStatus = {
  UPCOMING: { value: "UPCOMING", label: "All" },
  NEW_TO_WORKPLACE: { value: "NEW_TO_WORKPLACE", label: "New to your workplace" },
  IN_PROGRESS: { value: "IN_PROGRESS", label: "In Progress" },
  BLOCKED: { value: "BLOCKED", label: "Blocked" },
  PAST: { value: "PAST", label: "All" },
  STARRED: { value: "STARRED", label: "Starred" },
};

export const STARRED_PROFESSIONAL_COLOR = "#1890FF";
